/* tslint:disable */
/* eslint-disable */
/**
 * Onibi Portal Api
 * The API for the OnibiPortal Server project
 *
 * OpenAPI spec version: v1
 * Contact: info@yumebau.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import globalAxios, { AxiosResponse, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { Project } from '../models';
import { ProjectPagedResponse } from '../models';
/**
 * ProjectApi - axios parameter creator
 * @export
 */
export const ProjectApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Creates or edits a new project in the database.
         * @param {Project} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectAddOrEditPost: async (body?: Project, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Project/addOrEdit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary gets a  list of Servers from the db, with their associated project
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectGetServersGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Project/getServers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Lists all the projects in the database.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectListGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Project/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProjectApi - functional programming interface
 * @export
 */
export const ProjectApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Creates or edits a new project in the database.
         * @param {Project} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProjectAddOrEditPost(body?: Project, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<Project>>> {
            const localVarAxiosArgs = await ProjectApiAxiosParamCreator(configuration).apiProjectAddOrEditPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary gets a  list of Servers from the db, with their associated project
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProjectGetServersGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>> {
            const localVarAxiosArgs = await ProjectApiAxiosParamCreator(configuration).apiProjectGetServersGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Lists all the projects in the database.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProjectListGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<ProjectPagedResponse>>> {
            const localVarAxiosArgs = await ProjectApiAxiosParamCreator(configuration).apiProjectListGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ProjectApi - factory interface
 * @export
 */
export const ProjectApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Creates or edits a new project in the database.
         * @param {Project} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProjectAddOrEditPost(body?: Project, options?: AxiosRequestConfig): Promise<AxiosResponse<Project>> {
            return ProjectApiFp(configuration).apiProjectAddOrEditPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary gets a  list of Servers from the db, with their associated project
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProjectGetServersGet(options?: AxiosRequestConfig): Promise<AxiosResponse<void>> {
            return ProjectApiFp(configuration).apiProjectGetServersGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Lists all the projects in the database.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProjectListGet(options?: AxiosRequestConfig): Promise<AxiosResponse<ProjectPagedResponse>> {
            return ProjectApiFp(configuration).apiProjectListGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProjectApi - object-oriented interface
 * @export
 * @class ProjectApi
 * @extends {BaseAPI}
 */
export class ProjectApi extends BaseAPI {
    /**
     * 
     * @summary Creates or edits a new project in the database.
     * @param {Project} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectApi
     */
    public async apiProjectAddOrEditPost(body?: Project, options?: AxiosRequestConfig) : Promise<AxiosResponse<Project>> {
        return ProjectApiFp(this.configuration).apiProjectAddOrEditPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary gets a  list of Servers from the db, with their associated project
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectApi
     */
    public async apiProjectGetServersGet(options?: AxiosRequestConfig) : Promise<AxiosResponse<void>> {
        return ProjectApiFp(this.configuration).apiProjectGetServersGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Lists all the projects in the database.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectApi
     */
    public async apiProjectListGet(options?: AxiosRequestConfig) : Promise<AxiosResponse<ProjectPagedResponse>> {
        return ProjectApiFp(this.configuration).apiProjectListGet(options).then((request) => request(this.axios, this.basePath));
    }
}
